<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="guardar()"
    >
      <v-card-title>
        ANULACIÓN DE FACTURA
        <v-spacer/>
        <v-btn
            icon
            @click="close()"
        >
          X
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <span v-if="tipoAnulacion==='ConsumoAgua'">CONSUMO DE AGUA</span>
        <span v-else>OTROS INGRESOS</span>
      </v-card-subtitle>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
                v-if="tipoAnulacion === 'ConsumoAgua'"
                v-model="cuenta"
                label="Cuenta *"
                outlined
                autofocus
                maxlength="7"
                :rules="[v => !!v || 'Cuenta es requerida']"
                @keypress="patterns.onlyNumber($event)"
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field
                v-model="numeroFactura"
                label="Número de factura *"
                outlined
                maxlength="5"
                :rules="[v => !!v || 'Número de factura es requerida']"
                @keypress="patterns.onlyNumber($event)"
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-select
                label="Motivo *"
                v-model="motivo"
                :items="motivos"
                item-value="id"
                item-text="descripcion"
                outlined
                return-object
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-footer>
        <v-spacer/>
        <v-btn
            color="primary"
            type="submit"
            block
            :loading="loading"
        >
          Anular factura
        </v-btn>
      </v-footer>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import {Vue, Component, Prop} from "vue-property-decorator";
import {anulacionStore} from "@/store/anulacionStore";
import {AnulacionService} from "@/services/AnulacionService";
import {Pattern} from "@/addons/Pattern";
import { Alert } from "@/addons/Alert";

@Component({
  name: "AnulacionForm"
})
export default class AnulacionForm extends Vue {
  @Prop() tipoAnulacion!: string
  private patterns = Pattern;
  private anulacionStore = anulacionStore();
  private anulacionService = AnulacionService.getInstance();

  cuenta = null;
  numeroFactura = null;
  motivo = {
    "cod": "1",
    "descripcion": "FALTA DE PAGO"
  };

  valid = true;
  $refs!: {
    form: HTMLFormElement
  };

  get motivos() {
    return this.anulacionStore.motivos;
  }

  get isNewDialog(): boolean {
    return this.anulacionStore.isNewDialog;
  }

  get loading(): boolean {
    return this.anulacionStore.loading;
  }

  mounted() {
    this.anulacionService.getMotivosAnulacion();
  }

  async guardar() {
    if(!this.$refs.form.validate()){
      return;
    }

    Alert.confirm(`Número de factura:
                            <strong> ${this.numeroFactura}</strong> <br>
                        Motrivo: ${this.motivo.descripcion}

                        `, "¿Esta seguro que quiere anular la factura?").then(async result => {
      if(result.isConfirmed){
        const data = {
          cuenta: this.cuenta,
          numeroFactura: this.numeroFactura,
          motivo: this.motivo
        }
        await this.anulacionService.setAnulacion(data);
        this.limpiarCampos();
      }
    })
  }

  limpiarCampos(){
    this.cuenta = null;
    this.numeroFactura = null;
    this.motivo = {
      "cod": "1",
      "descripcion": "FALTA DE PAGO"
    };
  }
  close(){
    this.limpiarCampos();
    this.$emit('close');
  }
}
</script>

<style scoped>

</style>